export default __webpack_public_path__ + "static/media/nodejs.cd7cdd41.svg";